var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-wait',{attrs:{"for":"dashboard"}},[_vm._v(" "+_vm._s(_vm.$t('frontend_analytics_coming_soon'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }